"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6809,7770,3803,4588],{

/***/ 77770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26699);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32023);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8996);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);








function Disclaimer(_ref) {
  var _document$fields, _document$fields2, _document$fields4, _className;

  var children = _ref.children,
      id = _ref.id,
      className = _ref.className,
      styles = _ref.styles,
      whiteText = _ref.whiteText,
      document = _ref.document;
  var disclaimer = children ? children : document == null ? void 0 : (_document$fields = document.fields) == null ? void 0 : _document$fields.disclaimerText;
  var anchorId = '';

  if (id) {
    anchorId = id;
  } else if (document == null ? void 0 : (_document$fields2 = document.fields) == null ? void 0 : _document$fields2.name) {
    var _document$fields3;

    anchorId = (0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_4__/* .createHtmlFriendlyId */ .vG)(document == null ? void 0 : (_document$fields3 = document.fields) == null ? void 0 : _document$fields3.name);
  } else {
    anchorId = '';
  }

  if (!disclaimer) {
    return null;
  }

  if (className) {
    className = "ob-disclaimer ".concat(className);
  } else if (document == null ? void 0 : (_document$fields4 = document.fields) == null ? void 0 : _document$fields4.className) {
    var _document$fields5;

    className = "ob-disclaimer ".concat(document == null ? void 0 : (_document$fields5 = document.fields) == null ? void 0 : _document$fields5.className);
  } else {
    className = 'ob-disclaimer';
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
    className: className,
    "data-white-text": whiteText ? whiteText : (_className = className) == null ? void 0 : _className.includes('white-text'),
    style: styles,
    dangerouslySetInnerHTML: {
      __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_5___default().sanitize(disclaimer)
    }
  });
}

Disclaimer.defaultProps = {
  tag: 'p',
  className: '',
  styles: {},
  whiteText: false
};
/* harmony default export */ __webpack_exports__["default"] = (Disclaimer);

/***/ })

}]);